import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d9c6556"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"main\" data-v-9d9c6556><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-9d9c6556><circle cx=\"29.9999\" cy=\"29.9999\" r=\"25.5556\" fill=\"#F7981C\" data-v-9d9c6556></circle><path d=\"M28.333 16.1113V31.6669H42.7775\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-9d9c6556></path></svg><div class=\"title\" data-v-9d9c6556>日志自动分析中</div><div class=\"message\" data-v-9d9c6556>请您稍等片刻，请勿关闭当前页面<br data-v-9d9c6556></div></div>", 1)

import { useRouter, useRoute } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { analysisFlylog } from '@/apis/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'log-analysis',
  setup(__props) {

// 订单查询页，目前仅用于激活设备后购买跳转的链接，请求完激活信息进行跳转
const $router = useRouter()
const $route = useRoute()
const guid = $route.query.guid as string
const sn = $route.query.sn as string
const is_boom = $route.query.is_boom as string
const { malfunctionRepairState } = useMalfunctionRepairStore()
async function analysisHandle() {
  try {
    const data = await analysisFlylog(guid)
    malfunctionRepairState.analysisInfo = data
    $router.replace({
      name: 'malfunction-repair-network-list',
      query: {
        guid,
        sn,
        is_boom,
      },
    })
  } catch (error) {
    commonErrorHandle(error)
    // 不管什么情况失败就返回上一步
    setTimeout(() => {
      $router.go(-1)
    }, 1500)
  }
}
analysisHandle()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "日志分析" }),
    _hoisted_1
  ], 64))
}
}

})